





















































import {
    defineComponent,
    onMounted,
    onUnmounted,
    reactive,
    computed,
} from '@vue/composition-api';
import { getContentDetail } from './api';
import { getParseResult } from './components/RichContent/parseText';
import { getTimeAgo } from '@/common/date';
import { callApp } from './utils';
import { sendClickLog, immediateSendLog } from '@/common/log';

import { Loading as MLoading, Button as MButton } from '@kibt/meta-ui';
import CoEmpty from '@/components/CoEmpty/index.vue';
import DetailHeader from './components/DetailHeader/index.vue';
import ImageSwiper from './components/ImageSwiper/index.vue';
import RichContent from './components/RichContent/index.vue';
import ActionBar from './components/ActionBar/index.vue';

import topickTag from '@/assets/images/topickTag.png';
import locationIcon from '@/assets/images/location.png';

import { ContentDetail } from './type';

export default defineComponent({
    components: {
        MLoading,
        MButton,
        CoEmpty,
        DetailHeader,
        ImageSwiper,
        RichContent,
        ActionBar,
    },
    setup(_, { root }) {
        const state = reactive({
            loading: true,
            error: false,
            data: {} as ContentDetail,
        });

        const callAppOption = reactive({
            channel: '',

            shareId: '',
            shareUserId: '',
            shareSourceId: '',
            shareSourceOwner: '',
            shareSourceType: 'ITEM',
            shareDeviceId: '',
        });

        const hashTag = computed(() => {
            const parseResult = getParseResult(
                state.data?.description || ''
            )?.map(item => item.hashTagName);

            return (
                state.data?.hashTags?.filter(
                    item => !parseResult.includes(item?.tagName)
                ) || []
            );
        });

        function sendPvLog(pvParams = {}) {
            immediateSendLog({
                type: 'pv',
                name: 'DETAIL_SHARE',
                value: {
                    share_uid: callAppOption.shareUserId,
                    content_id: callAppOption.shareSourceId,
                    author_id: callAppOption.shareSourceOwner,
                },
                ...pvParams,
            });
        }

        async function init() {
            try {
                const itemId = root.$route.params?.id;
                callAppOption.channel = root.$route.query?.channel as string;

                callAppOption.shareId = root.$route.query?.shareId as string;
                callAppOption.shareUserId = root.$route.query?.uid as string;
                callAppOption.shareDeviceId = root.$route.query?.did as string;
                callAppOption.shareSourceId = itemId as string;

                state.loading = true;
                state.error = false;
                const data = await getContentDetail(itemId);
                state.data = data;
                callAppOption.shareSourceOwner = `${data?.authorId}`;
            } catch {
                state.error = true;
            } finally {
                sendPvLog();
                state.loading = false;
            }
        }

        function handleClickBtn() {
            sendClickLog({
                name: 'GUIDE_BUTTON',
            });
            callApp(callAppOption);
        }

        onMounted(async () => {
            await init();
        });

        onUnmounted(() => {
            sendPvLog({
                stateType: 'leave',
                auto: true,
            });
        });

        return {
            state,
            hashTag,

            getTimeAgo,
            callApp,
            handleClickBtn,
            init,

            callAppOption,
            topickTag,
            locationIcon,
        };
    },
});
